import Content from "components/Content"
import OffersActionButtons from "components/OffersActionButtons"
import TwoColumnLayout from "components/TwoColumnLayout"
import type { FC } from "react"
import { Trans } from "react-i18next"
import { Outlet, useNavigate, useParams } from "react-router-dom"
import OffersSidebar from "../../components/OffersSidebar"
import useOffersFilter from "../../hooks/useOffersFilter"
import type { Offer } from "../offersList/offersListTypes"
import OfferSkeleton from "../offersPdf/components/OfferSkeleton"
import MenuOfferItem from "./components/MenuOfferItem"
import useOffers from "./hooks/useOffers"

const Offers: FC = () => {
  const navigate = useNavigate()
  const { isLoading, data: offers } = useOffers()
  const { offerId } = useParams<Record<string, string | undefined>>()

  const {
    offers: filteredOffers,
    categories,
    programs,
    tags,
    updateFilter,
  } = useOffersFilter(offers || [])

  const handleClick = (offer: Offer) => {
    navigate(`/offers/${offer.CustomOfferID}`)
  }

  if (isLoading) {
    return (
      <div className="w-full h-full grid place-items-center p-2">
        <OfferSkeleton />
      </div>
    )
  }

  return (
    <Content title={<Trans i18nKey="offers.title" />}>
      <OffersActionButtons />

      <TwoColumnLayout
        sidebar={
          <OffersSidebar
            offers={filteredOffers}
            categories={categories}
            programs={programs}
            tags={tags}
            onFilterChange={updateFilter}
            renderOfferItem={(offer) => (
              <MenuOfferItem
                key={`${offer.Type}-${offer.CustomOfferID}`}
                offer={offer}
                checked={offerId === offer.CustomOfferID}
                onClick={() => handleClick(offer)}
              />
            )}
          />
        }
        content={<Outlet />}
      />
    </Content>
  )
}

export default Offers
